import {
  format, today, yesterday, differenceInDays,
  subWeeks, subMonths, subQuarters,
  startOfISOWeek, startOfMonth, startOfQuarter, startOfYear,
  endOfISOWeek, endOfMonth, endOfQuarter,
} from '../../../utils/date';

export const minGrowthRatePeriod = 28;
export const minGrowthRateSelectable = 60;
export const dayPeriods = [30, 60, 90, 180, 365, 730, 1095, 1460];
export const definedPeriods = ['week', 'month', 'quarter', 'year'];

export const definedPeriodsNames = {
  week: 'Previous Week',
  month: 'Previous Month',
  quarter: 'Previous Quarter',
  year: 'Year to Date',
};

export const dateRangeToSubmit = period => ({
  week: {
    rangePeriod: differenceInDays(
      endOfISOWeek(subWeeks(today(), 1)),
      startOfISOWeek(subWeeks(today(), 1)),
    ) + 1,
    from: format(startOfISOWeek(subWeeks(today(), 1))),
    to: format(endOfISOWeek(subWeeks(today(), 1))),
  },
  month: {
    rangePeriod: differenceInDays(
      endOfMonth(subMonths(today(), 1)),
      startOfMonth(subMonths(today(), 1)),
    ) + 1,
    from: format(startOfMonth(subMonths(today(), 1))),
    to: format(endOfMonth(subMonths(today(), 1))),
  },
  quarter: {
    rangePeriod: differenceInDays(
      endOfQuarter(subQuarters(today(), 1)),
      startOfQuarter(subQuarters(today(), 1)),
    ) + 1,
    from: format(startOfQuarter(subQuarters(today(), 1))),
    to: format(endOfQuarter(subQuarters(today(), 1))),
  },
  year: {
    rangePeriod: differenceInDays(yesterday(), startOfYear(today())) + 1,
    from: format(startOfYear(today())),
    to: format(yesterday()),
  },
})[period];

export const rangePeriodFromYesterday = period => ({
  week: differenceInDays(yesterday(), startOfISOWeek(subWeeks(today(), 1))) + 1,
  month: differenceInDays(yesterday(), startOfMonth(subMonths(today(), 1))) + 1,
  quarter: differenceInDays(yesterday(), startOfQuarter(subQuarters(today(), 1))) + 1,
  year: differenceInDays(yesterday(), startOfYear(today())) + 1,
})[period];

export const getActiveOption = (customFrom, customTo) => {
  if (customFrom && customTo) {
    const rangePeriod = differenceInDays(customTo, customFrom) + 1;

    // dayPeriods
    if (customTo === format(yesterday()) && dayPeriods.includes(rangePeriod)) {
      return {
        value: rangePeriod.toString(),
        label: (rangePeriod > 365 ? `Last ${parseInt(rangePeriod / 365, 10)} Years` : `Last ${rangePeriod} Days`),
      };
    }

    // definedPeriods
    const previousPeriods = definedPeriods.map(definedPeriod => ({
      value: definedPeriod,
      ...dateRangeToSubmit(definedPeriod),
    }));

    const activePeriod = previousPeriods.find(({ from, to }) =>
      (from === customFrom) && (to === customTo));

    if (activePeriod) {
      return {
        value: activePeriod.value,
        label: definedPeriodsNames[activePeriod.value],
      };
    }
  }

  return { value: 'custom', label: 'Custom' };
};
